//@flow
import {setState} from '$util'

export default function* changeLocale(locale: string): Generator<> {
  localStorage.setItem('frank-locale', locale)
  return yield setState('locale', () => locale)
}



// WEBPACK FOOTER //
// ./src/i18n/sagas/changeLocale.js